import React, { useState, useEffect, useContext, useLayoutEffect, useMemo } from 'react';
import { ReactSVG } from 'react-svg';
import { useDispatch, useSelector } from 'react-redux';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getApplicableCouponsAction,
  applyCoupon,
  removeCouponAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { UserOrderContext } from 'context/context';
import {
  getDispositionTypeOnAPIFormat,
  toastifyFnWithImage,
  isMobileDevice,
  getAndCheck,
  getAndCheckIfOneTrue,
  getTernaryValue,
  isCateringDisposition,
  getValueOrEmptyString,
} from 'common/utilities/utils';
import {
  modifyOffersData,
  getFinalContentData,
  isTimeValid,
  truncate,
} from 'organisms/PromosRewards/utils/promosRewardsUtils';
import { login } from 'common/utilities/LoginUtils';
import { getDispositionNewData } from 'organisms/MenusPLP/MenusPlpUtilities/MenuPLPSharedUtils';
import {
  setOffersAndPromotionsAnalyticsData,
  setRedeemOffersAndPromotionsAnalyticsData,
} from 'organisms/OffersAndPromotions/OffersAndPromotionsUtilities/offersAndPromotionsUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import TimerView from 'organisms/PromosRewards/Presentation/TimerView';
import PromosRewardsCard from 'organisms/PromosRewards/Presentation/PromosRewardsCard';
import PromosBanner from 'organisms/PromosRewards/Presentation/PromosBanner';
import SampleArrowNext from 'organisms/OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from 'organisms/OffersAndPromotions/Presentation/SampleArrowPrev';
import { PLP_PAGE, LOCAL_STORAGE_KEYS, ROUTE_URL, RESIZE } from 'common/constants/SharedConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { PROMOS_AND_REWARDS_CONSTANT } from 'organisms/PromosRewards/Constants/PromosRewardsConstant';
import ViewDetailsModal from 'organisms/PromosRewards/Presentation/ViewDetailsModal';
import MultiProductPromoModal from 'organisms/PromosRewards/Container/MultiProductPromoModal';
import ImageComponent from 'atoms/Image';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
const { ANALYTICS_EVENTS } = CART_PAGE_CONSTANTS;

export const PromosRewardsContainer = props => {
  const { page, isMobile, onClickScroll } = props;
  const {
    PROMOS_REWARDS,
    MEMBERS_ONLY,
    VIEW_ALL_PROMOS,
    CANCEL,
    PROMO_REMOVE_CONFIRMATION,
    PROMO_SUCCESS_TOAST_MESSAGE,
    PROMO_REMOVE_TOAST_MESSAGE,
    YES_REMOVE,
  } = TRANSLATE_MAPPING_KEY;
  const { StripesIcon, ViewDetailsArrowBlack, tickWhiteToast, TimerRibbonRedOutlined, TimerIcon } = IMAGE_PATH;
  const { CAROUSAL_CONFIG, CONTENT_DATA_MAX_LENGTH_TO_SCROLL, SILCK_RESPONSIVE_PROPERTY } = PROMOS_AND_REWARDS_CONSTANT;
  const { SPEED, SLIDES_TO_SHOW, SLIDES_TO_SCROLL } = CAROUSAL_CONFIG;
  const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const { loggedIn, localized } = userParams;
  const [offersContentData, setOffersContent] = useState([]);
  const [showModal, setModal] = useState(false);
  const [showConfirmationModel, setConfirmationModel] = useState(false);
  const [viewProductCardData, setProductCardData] = useState({});
  const [viewProductEvent, setProductviewProductEvent] = useState(null);
  const [viewDetailsData, setViewDetailsData] = useState({});
  const [showMultiProductModal, setMultiProductModal] = useState(false);
  const [promosApplied, setPromosApplied] = useState(false);
  const [promosState, setPromosState] = useState('null');
  const tenantData = useSelector(data => data?.tenantReducer);
  const { tenantId = '', componentOptions } = tenantData;
  const sendViewAllDealsEvent = getValueOrEmptyString(componentOptions?.web?.coupons?.sendViewAllDealsEvent);
  const cartReducer = useSelector(data => data?.cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer) || {};
  const { showPromoRewardsMessage = false } = tenantReducer?.componentOptions?.web?.cartPage;
  const { applicableCoupons = [], cartData: basketData = {} } = cartReducer;
  const { discountLines = [] } = basketData || {};
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const dispositionNew = getDispositionNewData(userOrderState);
  const params = useMemo(() => {
    return {
      dispositionType: dispositionNew?.type
        ? getDispositionTypeOnAPIFormat(dispositionNew.type)
        : getDispositionTypeOnAPIFormat(tenantData?.authoredContent?.defaultdisposition),
    };
  }, [dispositionNew, tenantData]);
  const { dispositionType } = params;
  const [rangeValue, updateRangeValue] = useState(0);
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [visibleCards, setVisibleCards] = useState(0);
  const [alertPopupCouponCode, setAlertPopupCouponCode] = useState('');
  let couponsInStorage = {};
  const carousal = React.useRef(null);
  const [imageContainerSize, setImageContainerSize] = useState(0);
  const getCouponLoading = useSelector(data => data.cartReducer?.getCouponLoading);
  const [isApplicableAPILoading, setApplicableAPILoading] = useState(true);
  const handleClose = () => {
    setModal(false);
  };
  const handleAlertClose = () => {
    setConfirmationModel(false);
  };
  const handleMultiProductClose = () => {
    setMultiProductModal(false);
  };

  const setMultiProductModalHandler = (productData, event) => {
    setProductCardData({
      item: productData?.item,
      titleValue: productData?.titleValue,
      promoParams: productData?.promoParameters,
      priceDetails: productData?.priceDetails,
    });
    setProductviewProductEvent(event);
    setMultiProductModal(true);
  };

  const setViewDetailsHandler = productData => {
    setViewDetailsData({ item: productData?.item });
    setModal(true);
  };

  const setGreenTickHandler = productData => {
    const couponCode = productData?.couponCode || '';
    setConfirmationModel(true);
    setAlertPopupCouponCode(couponCode);
  };

  /* OnClicking Next Arrow Button */
  const onNextCard = () => {
    if (currentSlide < offersContentData.length - 1) {
      let updatedCurrentSlide;
      if (currentSlide + SLIDES_TO_SCROLL > offersContentData.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = offersContentData.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
  };

  /* In dragging scroll bar */
  const onUpdateRange = event => {
    updateRangeValue(event.target.value);
    carousal.current.slickGoTo(event.target.value);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
    variableWidth: true,
    accessibility: true,
    responsive: SILCK_RESPONSIVE_PROPERTY,
  };

  useLayoutEffect(() => {
    const calculateMarginWidth = () => {
      return isMobileDevice(window.innerWidth) ? [250.0 + 37, 20.0] : [310.0 + 37, window.innerWidth * 0.1];
    };
    const calculateVisibleItems = () => {
      const [cardWidth, leftMargin] = calculateMarginWidth();
      const contentWidth = window.innerWidth - leftMargin;
      let visibleItems = Math.ceil(contentWidth / cardWidth);

      if (visibleItems === 1) {
        visibleItems += 1;
      }
      return visibleItems;
    };

    const handleResize = () => {
      setVisibleCards(calculateVisibleItems());
      setImageContainerSize(window.innerWidth);
    };

    window.addEventListener(RESIZE, handleResize);
    handleResize();
  }, []);

  useEffect(() => {
    if (applicableCoupons.length > 0) {
      const data = getFinalContentData(loggedIn, modifyOffersData(applicableCoupons, tenantData));
      setIsAppliedInApplicableCoupon(data, promosState);
    } else {
      if (!offersContentData.length) {
        const data = getFinalContentData(loggedIn, [], getCouponLoading);
        setOffersContent(data);
      }
      setApplicableAPILoading(
        getTernaryValue(getAndCheckIfOneTrue(offersContentData.length, applicableCoupons.length), false, true),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicableCoupons]);

  useEffect(() => {
    if (localized && tenantId && dispositionNew?.basketId !== basketData?.id) {
      getCoupons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    localized,
    loggedIn,
    basketData?.id,
    basketData?.customer?.id,
    tenantId,
    dispositionNew?.store?.id,
    dispositionNew?.type,
  ]);

  useEffect(() => {
    //get ApplicableCoupon api calling on coupon activation and removal
    if (promosState !== 'null') {
      getCoupons();
      let toastTxt = promosState
        ? translateWithI18Next(PROMO_SUCCESS_TOAST_MESSAGE)
        : translateWithI18Next(PROMO_REMOVE_TOAST_MESSAGE);
      showToast(toastTxt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountLines]);

  const setIsAppliedInApplicableCoupon = (data, appliedFlag) => {
    /** updating local storage */
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER)) {
      couponsInStorage = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER));
    }
    if (alertPopupCouponCode) {
      if (appliedFlag) {
        couponsInStorage[alertPopupCouponCode] = alertPopupCouponCode;
      } else if (couponsInStorage[alertPopupCouponCode]) {
        delete couponsInStorage[alertPopupCouponCode];
      }
      if (Object.keys(couponsInStorage).length > 0) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER, JSON.stringify(couponsInStorage));
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER);
      }
    }
    /** updating isApplied key in applicable coupon response */
    for (let promos in couponsInStorage) {
      let couponCode = couponsInStorage[promos];
      data = data.map(obj => (obj.couponCode === couponCode ? { ...obj, isApplied: appliedFlag } : obj));
    }
    /** updating state */
    setOffersContent(data);
    const checkPromoAppled = data.some(item => item.isApplied && !item.employeePromotion);
    setPromosApplied(checkPromoAppled);
    setApplicableAPILoading(
      getTernaryValue(getAndCheckIfOneTrue(offersContentData.length, applicableCoupons.length), false, true),
    );
  };
  const showToast = toastTxt => {
    let imageTemplate = <ImageComponent srcFile={tickWhiteToast} />;
    toastifyFnWithImage(toastTxt, imageTemplate, 'promos-rewards-toast promos-rewards-toast-pos');
  };
  const getCoupons = () => {
    const { customerId } = AuthManager.getInstance();
    if (localized && basketData?.id && customerId === basketData?.customer?.id) {
      dispatch(
        getApplicableCouponsAction({
          basketId: basketData?.id,
          tenantId,
        }),
      );
    }
  };

  const setLocationClickHandler = () => {
    dispatch(resetStores());
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS, '');
    localStorage.setItem(LOCAL_STORAGE_KEYS.SET_LOCATION, true);
  };

  const navigateToPromos = () => {
    props.history.push({
      pathname: ROUTE_URL.PROMOS_REWARDS,
    });
    if (sendViewAllDealsEvent) {
      setOffersAndPromotionsAnalyticsData({
        event: 'viewAllDeals',
      });
    }
  };
  /* show ribbon component  */
  const getRibbon = data => {
    if (data?.showTimer && isTimeValid(data?.validityEndTime)) {
      const header = (
        <span data-testid='promos-time-block' className='promos-time-block'>
          <img className='promos-time-icon' src={TimerIcon} alt='Timer Icon' />
          <TimerView endTime={data?.validityEndTime} />
        </span>
      );
      return (
        <div className={`promosRibbon-container ${page === PLP_PAGE && 'plp-promosRibbon-container'}`}>
          <ReactSVG src={TimerRibbonRedOutlined} className='promos-ribbon timer' />
          <span className='ribbon-text time-text'>{header}</span>
        </div>
      );
    } else if (data?.header) {
      const header = data?.header;
      return (
        <div className={`promosRibbon-container ${page === PLP_PAGE && 'plp-promosRibbon-container'}`}>
          <div className='angle-down'></div>
          <span className='ribbon-text-svg'>{truncate(header)}</span>
        </div>
      );
    }
  };
  const promosCarousel = promosData => {
    return promosData?.map((item, index) => {
      const { couponCode, smallText, titleValue, imageName, validityEndTime, promoParameters, itemDetails } = item;
      const priceDetails = itemDetails?.map(it => ({
        id: it?.id,
        availability: it?.availability,
      }));
      return (
        <div key={index}>
          <div
            className={`slick-slide offers-deals-card-container ${getAndCheck(page === PLP_PAGE, 'plp-slick-slide')}`}
          >
            <div
              className={`promos-card ${
                index === currentSlide + visibleCards - 1 && 'offersCard-fade lastOffersCard-fade'
              } ${page === PLP_PAGE && 'plp-promo-card'} ${
                !getRibbon(item) && getAndCheck(page === PLP_PAGE, 'overflow-class')
              }`}
            >
              {getRibbon(item)}
              <PromosRewardsCard
                data-testid='promos-rewards-card'
                loggedIn={loggedIn}
                localized={localized}
                couponCode={couponCode}
                smallText={smallText}
                titleValue={titleValue}
                imageName={imageName}
                item={item}
                promoParameters={promoParameters}
                priceDetails={priceDetails}
                validityEndTime={validityEndTime}
                tenantId={tenantId}
                setModal={setModal}
                setViewDetailsHandler={setViewDetailsHandler}
                setConfirmationModal={setGreenTickHandler}
                showMultiProductModal={setMultiProductModalHandler}
                dispositionType={dispositionType}
                addToOrderClickHandler={onAddToOrderClick}
                startOrderClickHandler={onStartOrderClick}
                promosApplied={promosApplied}
                basketData={basketData}
                setViewCartHandler={setViewCartHandler}
                setDispositionHandler={setDispositionHandler}
                createSignInURL={login}
                page={page}
                setAlertPopupCouponCode={setAlertPopupCouponCode} //added only for test case
                setIsAppliedInApplicableCoupon={setIsAppliedInApplicableCoupon} // added only for test case
              />
            </div>
          </div>
        </div>
      );
    });
  };
  const onAddToOrderClick = productData => {
    const couponCode = productData?.couponCode;
    dispatch(
      applyCoupon(
        {
          basketId: basketData?.id,
          tenantId,
        },
        {
          couponCode: couponCode,
        },
      ),
    );
    setPromosState(true);
    setAlertPopupCouponCode(couponCode);
  };

  const onStartOrderClick = (productData, event) => {
    const couponCode = productData?.couponCode;
    if (page === PLP_PAGE) {
      onClickScroll();
    } else {
      props.history.push({
        pathname: getTernaryValue(
          isCateringDisposition(dispositionType),
          ROUTE_URL?.CATERING_PAGE,
          `${ROUTE_URL.MENU_PAGE}`,
        ),
        isStartOrderClick: true,
      });
    }

    if (sendViewAllDealsEvent) {
      setRedeemOffersAndPromotionsAnalyticsData({
        event: ANALYTICS_EVENTS.REDEEM_OFFER,
        offerTitle: couponCode,
      });
    }
  };
  const removeAppliedCoupon = (productData, event) => {
    if (alertPopupCouponCode) {
      dispatch(
        removeCouponAction({
          basketId: basketData?.id,
          tenantId,
          couponCode: alertPopupCouponCode,
        }),
      );
      handleAlertClose();
      setPromosState(false);
    }
  };
  const setViewCartHandler = productData => {
    const couponCode = productData?.couponCode;
    props.history.push({
      pathname: ROUTE_URL.CART,
    });
    if (sendViewAllDealsEvent) {
      setRedeemOffersAndPromotionsAnalyticsData({
        event: ANALYTICS_EVENTS.REDEEM_OFFER,
        offerTitle: couponCode,
      });
    }
  };
  const setDispositionHandler = selectedDispositionType => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  };

  return (
    showPromoRewardsMessage && (
      <div
        id='promosRewards'
        className={`promos-container ${getTernaryValue(
          getAndCheck(page === PLP_PAGE, localized),
          'plp-promos-container',
          '',
        )} ${getTernaryValue(getAndCheck(isApplicableAPILoading, localized), 'plp-promos-loading', '')}`}
        data-testid='promos-container-test'
      >
        <div
          className={`promosCard-container grid-container ${getAndCheck(
            page === PLP_PAGE,
            'plp-promosCard-container',
          )} ${getAndCheck(page === PLP_PAGE, localized) && 'plp-promocard'}`}
          data-testid='promosCard-container-test'
        >
          {page !== PLP_PAGE && (
            <div className='promos-Icon'>
              <ReactSVG src={StripesIcon} />
            </div>
          )}
          <div
            className={`promosContainerHeader-items ${getAndCheck(
              page === PLP_PAGE,
              'plp-promosContainerHeader-items',
            )}`}
          >
            <h2 className='promosContainer-header'>{translateWithI18Next(PROMOS_REWARDS)}</h2>
            {localized && !loggedIn && <div className='promosHeader-text'>{translateWithI18Next(MEMBERS_ONLY)}</div>}
            {localized && getAndCheckIfOneTrue(!isMobile, page !== PLP_PAGE) && (
              <>
                <div className={`view-all-text ${page === PLP_PAGE && 'plp-view-all-promo-link'}`}>
                  <button
                    className='offersViewAll-link promosHeader-right-text promos-link'
                    onClick={() => navigateToPromos()}
                    data-testid='view-all-deals-handler'
                  >
                    {translateWithI18Next(VIEW_ALL_PROMOS)}
                  </button>
                  <ReactSVG className='promosViewAlldeals-arrow' src={ViewDetailsArrowBlack} />
                </div>
              </>
            )}
            {getAndCheck(isMobile, localized) && page === PLP_PAGE && (
              <div className='plp-card-count'>
                {currentSlide + 1}/{offersContentData.length}
              </div>
            )}
          </div>
          {localized && (
            <>
              <div className='promosCard-list'>
                {isApplicableAPILoading && (
                  <div className='placeholder'>
                    {Array(3)
                      .fill()
                      .map(() => (
                        <div className='table store-card-container'>
                          <div className='loading card-title shorter-s' />
                          <div className='loading table-content' />
                          <div className='loading table-content' />
                        </div>
                      ))}
                  </div>
                )}
                {getAndCheck(offersContentData.length, !isApplicableAPILoading) && (
                  <div className={`promosCarousal-list ${getAndCheck(page === PLP_PAGE, 'plp-promosCarousal-list')}`}>
                    <CarauselComp settings={settings} carousalRef={carousal}>
                      {promosCarousel(offersContentData)}
                    </CarauselComp>
                  </div>
                )}
                {getAndCheck(offersContentData.length > CONTENT_DATA_MAX_LENGTH_TO_SCROLL, !isApplicableAPILoading) && (
                  <div
                    className={`promos-slideContainer ${getAndCheck(page === PLP_PAGE, 'plp-promos-slideContainer')}`}
                  >
                    <input
                      className='promos-slider'
                      type='range'
                      data-testid='promo-slider-id'
                      min='0'
                      max={offersContentData.length - SLIDES_TO_SHOW}
                      value={rangeValue}
                      id='myRange'
                      onChange={onUpdateRange}
                      tabIndex='-1'
                      aria-hidden='true'
                    />
                  </div>
                )}
              </div>
              {getAndCheck(isMobile, page === PLP_PAGE) && (
                <div className='view-all-text plp-view-all-promo-text'>
                  <button
                    className='offersViewAll-link promosHeader-right-text promos-link'
                    onClick={() => navigateToPromos()}
                    data-testid='view-all-deals-handler'
                  >
                    {translateWithI18Next(VIEW_ALL_PROMOS)}
                  </button>
                  <ReactSVG className='promosViewAlldeals-arrow' src={ViewDetailsArrowBlack} />
                </div>
              )}
            </>
          )}
        </div>
        {!localized && (
          <PromosBanner data-testid='promos-banner-id' setLocationClickHandler={setLocationClickHandler} page={page} />
        )}

        {showModal && (
          <ViewDetailsModal
            history={props.history}
            data-testid='view-details-modalId'
            tenantId={tenantId}
            viewDetailsData={viewDetailsData}
            handleClose={handleClose}
          />
        )}
        {getAndCheck(showMultiProductModal, imageContainerSize) && (
          <MultiProductPromoModal
            data-testid='multi-product-modalId'
            viewProductEvent={viewProductEvent}
            history={props.history}
            tenantId={tenantId}
            viewProductCardData={viewProductCardData}
            handleClose={handleMultiProductClose}
            imageContainerSize={imageContainerSize}
          />
        )}

        {showConfirmationModel && (
          <AlertFormInsideModel
            data-testid='remove-promo-modal'
            handleClose={handleAlertClose}
            classNames='promos-rewards-warning-msg'
            CartAlertForm={
              <AlertForm
                splitTitle={{ MSGTXT1: `${translateWithI18Next(PROMO_REMOVE_CONFIRMATION)}` }}
                imageSrc={IMAGE_PATH.CartError}
                confirmButtonText={translateWithI18Next(YES_REMOVE)}
                cancelButtonText={translateWithI18Next(CANCEL)}
                confirmHandler={removeAppliedCoupon}
                cancelHandler={handleAlertClose}
                buttonContainerClass='deeplink-alert-btn-container alert-btn-container'
                data-testid='alert-form-modalId'
              />
            }
          />
        )}
      </div>
    )
  );
};

export default PromosRewardsContainer;
